import { createReducer } from '@reduxjs/toolkit';
import { IQualificationState } from './types';
import { fetchQualificationList } from './actions';

const initialState: IQualificationState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

export const qualificationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchQualificationList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchQualificationList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchQualificationList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});
